import { z } from 'zod'

const EntityCoreSchema = z.object({
  id: z.string(),
  name: z.string(),
  template_installation_id: z.number().nullable(),
  corrupted_messages: z.array(z.string()).optional(),
})

const OtnReasonSchema = EntityCoreSchema.extend({
  request_title: z.string().nullable(),
})

export const EntitiesSchema = z.object({
  tags: z.array(EntityCoreSchema),
  zapier_events: z.array(EntityCoreSchema),
  custom_fields: z.array(EntityCoreSchema),
  global_fields: z.array(EntityCoreSchema),
  custom_events: z.array(EntityCoreSchema),
  otn_reasons: z.array(OtnReasonSchema),
  apps: z.array(EntityCoreSchema),
})
